import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Loading, NewFooter } from "../../../components";
import { func } from "../../../utils";
import { SwooshSVG } from "../../JadwalPertandingan/JadwalPertandingan.styled";

import Section from "../../../components/atoms/Section";
import useWindowSize from "../../../hooks/useWindowSize";
import { ContentWrapper, InnerContentWrapper } from "./KlasemenPertandingan.styled";
import GroupTable from "./components/GroupTable";
import dummyData from "./dummy-data.json";
import {
  useFetchClassmentsDetails,
  useFetchClassmentsDetailsV2,
  useFetchCurrentEventSeries,
  useFetchEventCategory,
  useFetchEventSeriesDetail,
  useFetchRegionEventSeries,
} from "../../../networks";
import TopStats from "./components/TopStats";
import { buildPreviewGroups, restructureToGroupArray } from "./helper";
import { usePageContextFunction } from "../../../context/PageContext";
import { EmptyStateWrapper } from "../../../components/molecules/v2/TimelineSection/TimelineSection.styled";
import Show from "../../../components/atoms/Show/Show";
import { ReactComponent as EmptyState } from "../../../components/molecules/v2/TimelineSection/assets/empty-state.svg";
// @ts-ignore
import { ReactComponent as EmptyStateDesktop } from "../../../components/molecules/v2/TimelineSection/assets/empty-state-desktop.svg";
import PointSupporterStateCard from "../../../components/atoms/CardStatistik/PoinSupporter";
import moment from "moment";
import { findCurrentRegion } from "../../../utils/region";
const TEAM_PER_GROUP_LABEL = 4;

// Nama kategori di endpoint event/category. Dicocokin lewat nama, bukan id
// hardcode, ngikutin pola InitialRegistPopup — id-nya kebetulan sama di dev &
// prod, tapi jangan diandelin.
const CATEGORY_NAME = {
  SMA: "Futsal SMA",
  SMP: "Futsal SMP",
  Kuliah: "Futsal Kampus",
};
const SHOW_POIN_SUPPORTER = false;

const KlasemenPertandinganSocPage = ({ activeClassLevel = "SMA" }) => {
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;
  const { city } = useParams();
  const { setCity } = usePageContextFunction();
  const { search } = useLocation();
  const { data: dataRaw } = useFetchRegionEventSeries();
  // Check if URL includes /soc and year parameter conditions
  const urlParams = new URLSearchParams(search);
  const yearParam = urlParams.get("year");
  const isSOCPath = window.location.pathname.includes("/soc");
  const shouldUseSOC2025 = isSOCPath && (yearParam === "2025" || !yearParam);

  const dataRegistCity = dataRaw?.data?.data?.eventSeries || [];

  // Musim berjalan ditentukan `event/current-series`, bukan tanggal terbaru di
  // region/series. Tanpa ini Tangerang ke-resolve ke region 2025 (id 42) dan
  // Tabel Series nampilin klasemen musim lalu; region musim ini (id 74)
  // standing-nya masih kosong.
  const { data: dataCurrentSeriesRaw, isFetching: fetchingCurrentSeries } =
    useFetchCurrentEventSeries();
  const dataCurrentSeries = (
    dataCurrentSeriesRaw?.data?.data?.eventSeries || []
  ).flatMap((group) => group?.events || []);

  // Jangan resolve selagi current-series masih loading, biar klasemen musim
  // lalu ga sempat kedip lewat fallback lama.
  const dataCityAttribute = fetchingCurrentSeries
    ? undefined
    : findCurrentRegion(dataRegistCity, city, dataCurrentSeries);
  const { data: dataSeriesDetailRaw } = useFetchEventSeriesDetail("soc");

  const dataSeriesDetailRegionId = (
    dataSeriesDetailRaw?.data?.data?.eventSeries?.[0]?.region_series || []
  )?.find((item) => item?.is_soc)?.id;

  const currentDate = moment();
  const endDate = moment(dataCityAttribute?.event_end_date);

  const isWhitelistCity = ["lampung", "pontianak", "yogyakarta"].includes(city);
  const dataCityAttributeId = shouldUseSOC2025 ? dataSeriesDetailRegionId : dataCityAttribute?.id;

  // Tanpa category, get-match-standing balikin array kosong walau datanya ada.
  const { data: dataEventCategoryRaw } = useFetchEventCategory();
  const categoryName = CATEGORY_NAME[activeClassLevel] || CATEGORY_NAME.SMA;
  const categoryId = (
    dataEventCategoryRaw?.data?.data?.event_categories || []
  )?.find(
    (item) =>
      String(item?.category_name)?.toLowerCase() === categoryName.toLowerCase(),
  )?.id;

  const { data: dataClassmentsDetailsRaw, isFetching } = useFetchClassmentsDetailsV2(
    dataCityAttributeId,
    categoryId,
  );
  const dataClassmentsDetailRaw =
    restructureToGroupArray(dataClassmentsDetailsRaw?.data || {})?.data?.data ?? [];

  // Belum ada klasemen yang masuk: tampilin bagan contoh sesuai struktur
  // kompetisi biar bentuk tabelnya kebayang, bukan layar kosong. Ditandai
  // sebagai contoh di bawah tabel supaya ga disangka data beneran.
  const hasGroupData = dataClassmentsDetailRaw?.some((segment) => segment?.stage_type_id === 1);
  const isPreview = !hasGroupData;
  const dataClassmentsDetail = isPreview
    ? buildPreviewGroups(activeClassLevel)
    : dataClassmentsDetailRaw;

  React.useEffect(() => {
    // @ts-ignore
    setCity(city);
  }, [city]);

  if (isFetching) return <Loading />;

  return (
    <>
      <Section
        id="klasemen-pertandingan"
        height={"auto"}
        overflowY={"auto"}
        backgroundColor={"transparent"}
      >
        <ContentWrapper>
          <Show
            when={!dataClassmentsDetail?.filter((segment) => segment?.stage_type_id === 1)?.length}
          >
            <EmptyStateWrapper style={{ marginTop: 30 }}>
              {isMobileView ? <EmptyState /> : <EmptyStateDesktop />}
            </EmptyStateWrapper>
          </Show>
          <Show
            when={dataClassmentsDetail?.filter((segment) => segment?.stage_type_id === 1)?.length}
          >
            <InnerContentWrapper>
              {dataClassmentsDetail
                ?.filter((segment) => segment?.stage_type_id === 1)
                .map((val, index) => {
                  const title = val?.name;
                  const groupsData = [val];
                  return (
                    <div key={index} className="my-4">
                      {shouldUseSOC2025 ? null : (
                        <b className="text-white font-semibold text-[18px] block text-center mb-4">
                          {title}
                        </b>
                      )}
                      <GroupTable
                        data={groupsData}
                        isWhitelistCity={isWhitelistCity}
                        activeClassLevel={activeClassLevel}
                      />
                      {/* <TopStats /> */}
                    </div>
                  );
                })}
              <div className="flex gap-2 items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <circle cx="12" cy="12" r="12" fill="#77B341" />
                </svg>
                <span className="text-[#DDE2E8] font-semibold text-[18px]">
                  NB: Lolos tahap knockout
                </span>
              </div>
              {/* Section Poin Supporter disembunyikan dulu atas permintaan PM.
                  Balikin dengan mengubah flag ini ke true. */}
              {SHOW_POIN_SUPPORTER && !isWhitelistCity && !shouldUseSOC2025 ? (
                <div className="mt-6">
                  <PointSupporterStateCard text={"Top Scorer"} data={[]} />
                </div>
              ) : !shouldUseSOC2025 ? (
                <></>
              ) : null}
            </InnerContentWrapper>
          </Show>
        </ContentWrapper>
      </Section>
    </>
  );
};

export default KlasemenPertandinganSocPage;
